export const defaultPlexColors = [
  '#f44336',
  '#2196f3',
  '#4caf50',
  '#fbbd06',
  '#795548',
  '#00bcd4',
  '#473a34',
  '#673ab7',
  '#c6aeba',
  '#ff5722',
];

export const getTextColor = (backgroundColorHex: string): string => {
  return getContrastYIQ(backgroundColorHex);
};

/**
 * source: https://24ways.org/2010/calculating-color-contrast
 * @param hexcolor
 */
const getContrastYIQ = (hexcolor: string): string => {
  hexcolor = hexcolor.replace('#', '');
  if (hexcolor.length === 3) {
    hexcolor = `${hexcolor[0]}${hexcolor[0]}${hexcolor[1]}${hexcolor[1]}${hexcolor[2]}${hexcolor[2]}`;
  }
  if (hexcolor.length !== 6) {
    throw new Error(`Wrong color size: ${hexcolor.length}`);
  }
  const r = parseInt(hexcolor.substr(0, 2), 16);
  const g = parseInt(hexcolor.substr(2, 2), 16);
  const b = parseInt(hexcolor.substr(4, 2), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? 'black' : 'white';
};
